import styled from 'styled-components';

export const VideoSection = styled.div`
  margin: 20px 0;
`;

export const FAQSection = styled.div`
  margin: 20px 0;
`;

export const AccordionSection = styled.div`
  margin-top: 5px;
  height: 185px;
  overflow-y: scroll;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LinkImage = styled.img`
  width: 151px;
  height: 90px;
`;
